(function (angular) {
    "use strict";
    var fmgCommon = angular.module('common-services');

    fmgCommon.controller('ProductsController', function ($scope, authenticationService, $location, $window) {

        $scope.initDone = false;
        $scope.productCount = 0;

        var products = [];
        products.push({
                name: 'User Management Self Service',
                icon: 'action:account_box',
                hasRole: function (userToken) {
                    return _.some(userToken.roles, function (grp) {
                        return false;//Disabled For Now
                        //return grp === 'ORG-USER-MGR' || grp === 'GLOBAL-USER-MGR';
                    });
                },
                navigateTo: function () {
                    $window.location.href = $window.location.protocol + '//' + $window.location.host + '/usr-mgr-app';
                }
            }
        );
        products.push({
                name: 'HE Portal',
                icon: 'maps:directions',
                hasRole: function (userToken) {
                    return _.some(userToken.roles, function (grp) {
                        return grp === 'HE-OPERATOR' || grp === 'HE-FINANCE';
                    });
                },
                navigateTo: function () {
                    $window.location.href = $window.location.protocol + '//' + $window.location.host + '/he-app';
                }
            }
        );
        products.push(
            {
            name: 'Incident Management',
            className : 'imProd',
            icon: 'image:transform',
            hasRole: function (userToken) {
                return _.some(userToken.roles, function (grp) {
                    return grp === 'FIM-OPERATOR' || grp === 'FIM-CLIENT';
                });
            },
            navigateTo: function () {
                $window.location.href = $window.location.protocol + '//' + $window.location.host + '/im-app';
            }
        }
        );
        products.push(
            {
            name: 'Customer Portal Reporting',
            className : 'custPortalProd',
            icon: 'action:assessment',
            hasRole: function (userToken) {
                return _.some(userToken.roles, function (grp) {
                    return grp === 'FIM-TAM-REPORT';
                });
            },
            navigateTo: function () {
                $window.location.href = $window.location.protocol + '//' + $window.location.host + '/customer-portal-app';
            }
        });
        products.push({
            name: 'RISK',
            icon: 'action:timeline',
            hasRole: function (userToken) {
                return _.some(userToken.roles, function (grp) {
                    return grp === 'ID-DRIVER' || grp === 'ID-FLEET-MGR' || grp === 'ID-INTERNAL' || grp === 'ID-SUPPLIER' || grp === 'ID-OPERATOR';
                });
            },
            navigateTo: function () {
                $window.location.href = $window.location.protocol + '//' + $window.location.host + '/id-app';
            }
        });

        $scope.claims = authenticationService.getToken().roles;

        $scope.OnInit = function (autoNavigate) {
            var userToken = authenticationService.getToken();

            $scope.activatedProducts = _.filter(products, function (p) {
                return p.hasRole(userToken);
            });

            $scope.productCount = $scope.activatedProducts.length;

            if ($scope.activatedProducts.length === 0) {
                $scope.initDone = true;
                //Should not happen
            } else if ($scope.activatedProducts.length === 1) {
                //Only Single Product - Navigate to it
                if(autoNavigate === true){
                    $scope.activatedProducts[0].navigateTo();
                }else{
                    $scope.initDone = true;
                }

            }else{
                //Only mark init as done, if we are not going to auto redirect
                $scope.initDone = true;

            }
        };
    });

    fmgCommon.directive('fmgAppSwitch', function () {
        return {
            restrict: 'E',
            scope: {

            },
            controller: ['$scope', function ($scope) {

            }],
            templateUrl: 'common-app/_appSwitch.html'
        };
    });
})(window.angular);